.pdpReviewsPopoverLink {
  cursor: pointer;
  color: var(--colors-text-main);
  background-image: linear-gradient(
    to right,
    var(--colors-grays-black) 50%,
    transparent 50%
  );
  background-position: bottom;
  background-repeat: repeat-x;
  background-size: 4px 1px;
  transition: all 0.25s;
  line-height: 24px;
}

.pdpReviewsPopoverNotSignedIn {
  cursor: pointer;
}

.pdpReviewWrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;

  :global(#popover-content) > div:first-of-type {
    max-height: 600px;
  }
}

.pdpReviewsLinkButtons {
  display: flex;
  flex-direction: row-reverse;
  gap: 16px;
  line-height: 1;
  align-items: flex-end;
}

.pdpReviewsActivitiesDividerMobile {
  display: block;
  background-color: var(--colors-grays-light);
  height: 1px;
  border: none;
  margin: 24px -24px;
}

.pdpReviewsLinkContainerFull {
  display: flex;
  justify-content: space-between;
}

.pdpReviewsLinkContainer {
  display: flex;
  justify-content: flex-end;
}

@media all and (--reefer-media-tablet-min) {
  .pdpReviewReportFormContainer {
    width: 500px;
  }

  .pdpReviewWrapper {
    border-bottom: 1px solid var(--colors-grays-light);
    margin-bottom: 32px;
    padding-bottom: 24px;
  }

  .pdpReviewsActivitiesDividerMobile {
    display: none;
  }
}
